import React from "react";
import { Button, Col, Row } from "react-bootstrap";

// Constants
const baseURL = process.env.REACT_APP_API;

/**
 * Previsualización de un mensaje al que se está respondiendo
 *
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.reply - Objeto de respuesta
 * @param {Function} props.setReply - Función para establecer la respuesta
 * @param {Boolean} props.isReplyingMessage - Indica si se está respondiendo un mensaje
 * @returns {JSX.Element} Componente de React
 */
const ReplyingMessage = ({ reply, setReply, isReplyingMessage = false }) => {
  // Extrae los datos de la respuesta, depende si es un mensaje o una respuesta
  const status = isReplyingMessage ? reply.status : reply.rstatus;
  const type = isReplyingMessage ? reply.type : reply.rty;
  const object = isReplyingMessage ? reply.object : reply.robj;
  const comment = isReplyingMessage ? reply.coment : reply.rcom;
  const payload = reply?.payload && reply.red === "telegram" ? JSON.parse(reply.payload) : null;

  // Tipos de renderizado
  const renderTypes = {
    text: () => (
      <span className="font-14">
        {payload ? payload.payload.payload.postbackText : object}
      </span>
    ),
    image: () => (
      <div className="d-flex justify-content-between align-items-center gap-2">
        {comment ? (
          <span className="font-14">{comment}</span>
        ) : (
          <div>
            <i className="uil uil-image font-16 me-1 d-inline-block" />
            <span className="font-14">Imagen</span>
          </div>
        )}
        <img
          src={`${baseURL}/${object}`}
          alt="media"
          height={isReplyingMessage ? 80 : 48}
          className="rounded"
        />
      </div>
    ),
    file: () => (
      <>
        <i className="mdi mdi-file font-15 d-inline-block me-1" />
        <span className="font-14">{comment ? comment : "Archivo"}</span>
      </>
    ),
    audio: () => (
      <>
        <i className="uil uil-microphone font-15 d-inline-block me-1" />
        <span className="font-14">{comment ? comment : "Audio"}</span>
      </>
    ),
    video: () => (
      <>
        <i className="uil uil-video font-15 d-inline-block me-1" />
        <span className="font-14">{comment ? comment : "Video"}</span>
      </>
    ),
    map: () => (
      <>
        <i className="uil uil-location-point font-15 d-inline-block me-1" />
        <span className="font-14">{comment ? comment : "Ubicación"}</span>
      </>
    ),
    contact: () => {
      const contactName = JSON.parse(object).name;
      return (
        <>
          <i className="uil uil-user font-15 d-inline-block me-1" />
          <span className="font-14">{contactName}</span>
        </>
      );
    },
    sticker: () => (
      <>
        <i className="uil uil-smile font-15 d-inline-block me-1" />
        <span className="font-14">Sticker</span>
      </>
    ),
  };

  // Renderiza el contenido del mensaje
  const renderContent = () => {
    const RenderComponent = renderTypes[type] || renderTypes["text"];
    return RenderComponent ? RenderComponent() : null;
  };

  return (
    <Row className="d-flex align-items-center">
      <Col xl={isReplyingMessage ? 11 : 12}>
        <div
          className={`${
            isReplyingMessage ? "bg-input" : "bg-reply"
          } border-start ${
            status === "res" ? "border-success" : "border-primary"
          } border-5 px-2  text-start`}
          style={{
            borderRadius: "8px",
            boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <span className="font-13 fw-bold">
            {status === "send" ? "Tú" : "Cliente"}
          </span>
          <div>{renderContent()}</div>
        </div>
      </Col>

      {/* Si se está respondiendo un mensaje, muestra el botón para cancelar */}
      {isReplyingMessage && (
        <Col xl={1} className="d-flex justify-content-end p-0">
          <Button
            variant="link"
            className="text-secondary"
            onClick={() => setReply(null)}
          >
            <i className="uil uil-times h2" />
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default ReplyingMessage;
